export const BUCKET_SUFFIX = 'appspot.com/';
export const CDN_URL_DEV = 'https://cdn.pedix.dev';
export const CDN_URL_PROD = 'https://cdn.pedix.app';
export const ONBOARDING_ASSETS_BUCKET = 'pedix-onboarding-assets';
export const ONBOARDING_ASSETS_CDN_PREFIX = 'onboarding-assets';

export const ONBOARDING_ASSETS_URL_PREFIX = `https://storage.googleapis.com/${ONBOARDING_ASSETS_BUCKET}/`;

export type CdnImageOptions = {
  size?: string;
  quality?: number;
};

export const getImageCdnUrl = (
  imageUrl: string,
  options: Partial<CdnImageOptions> = {},
  env: 'development' | 'production',
): string => {
  if (!imageUrl) {
    return '';
  }
  const cdnUrl = env === 'development' ? CDN_URL_DEV : CDN_URL_PROD;

  if (
    imageUrl.startsWith(CDN_URL_DEV) ||
    imageUrl.startsWith(CDN_URL_PROD) ||
    imageUrl.startsWith('data:image')
  ) {
    return imageUrl;
  }

  const baseImageUrl = imageUrl.split('?')[0];
  const parsedImagePath = getCdnImagePath(baseImageUrl);

  if (!parsedImagePath) {
    return imageUrl;
  }

  const searchParams = new URLSearchParams();

  if (options.size) {
    searchParams.append('size', options.size);
  }
  if (options.quality) {
    searchParams.append('quality', options.quality.toString());
  }
  const searchString = searchParams.size > 0 ? `?${searchParams.toString()}` : '';

  return `${cdnUrl}/${parsedImagePath}${searchString}`;
};

const getCdnImagePath = (baseImageUrl: string): string | null => {
  if (baseImageUrl.startsWith(ONBOARDING_ASSETS_URL_PREFIX)) {
    return `${ONBOARDING_ASSETS_CDN_PREFIX}/${baseImageUrl.substring(
      ONBOARDING_ASSETS_URL_PREFIX.length,
    )}`;
  }

  const bucketIndex = baseImageUrl.indexOf(BUCKET_SUFFIX);

  if (bucketIndex === -1) {
    return null;
  }
  const imagePath = baseImageUrl.substring(bucketIndex + BUCKET_SUFFIX.length);

  return baseImageUrl.startsWith('https://firebasestorage.googleapis.com')
    ? decodeURIComponent(imagePath.replace(/^o\//, ''))
    : imagePath;
};
